import React, {Component,useRef} from 'react';
import {connect} from 'react-redux';
import { inject, observer } from 'mobx-react';
import { makeObservable, observable, reaction } from 'mobx';


const ContentEditableWithRef = observer((props) => {
  const defaultValue = useRef(props.value);

  const handleInput = (event) => {
    if (props.onChange) {
      props.onChange(event.target.innerHTML);
    }
  };

  return (
    <div
      contentEditable
      onInput={handleInput}
      className={`custom-textarea ${props.className}`}
      dangerouslySetInnerHTML={{ __html: defaultValue.current }}
    />
  );
});

class ContentEditable extends Component {
  show_placeholder=true;
  constructor(props) {
    super(props);

    this._initialVal=props.linker.value;

    makeObservable(this,{
      show_placeholder:observable
    })

    this.reactions=[];
    this.reactions.push(reaction(()=>{ return this.props.linker.value; },(val)=>{
      if(val !== this._ref.innerHTML) {
        this._ref.innerHTML=val;
      }
    }));
    this.reactions.push(reaction(()=>{ return this.props.linker.value; },(val)=>{
      if(val.length>0) {
        this.show_placeholder=false;
      } else {
        this.show_placeholder=true;
      }
    },{ fireImmediately:true }));
  }
  componentWillUnmount() {
    for(let i in this.reactions) {
      this.reactions[i]();
    }
  }
  loadCursorPos() {
    if(this.lastRange) {
      const sel = window.getSelection();
      const range = sel.getRangeAt(0);
      range.setStart(this._ref.firstChild, this.lastRange.start);
      range.setEnd(this._ref.firstChild, this.lastRange.end);
      sel.removeAllRanges();
      sel.addRange(range);
      console.log('this._ref.firstChild', this._ref.firstChild, this.lastRange);
    }
  }
  onKeyDown(e) {
    if(e.which === 13) {
      if (!e.shiftKey) {
        this.props.onEnter();
        e.preventDefault();
      }
    }
  }
  onKey(e) {

    if(e.which === 13) {
      if(!e.shiftKey) {
        if (this.props.onEnter) {
          this.props.onEnter();
          e.preventDefault();
        }
      } else {
        //document.execCommand('insertHTML', false, '');
        if (window.getSelection) {
          var selection = window.getSelection(),
            range = selection.getRangeAt(0),
            br = document.createElement("br");
          range.deleteContents();
          range.insertNode(br);
          range.setStartAfter(br);
          range.setEndAfter(br);
          range.collapse(false);
          selection.removeAllRanges();
          selection.addRange(range);

          if (!this._ref.lastChild || this._ref.lastChild.nodeName.toLowerCase() != "br") {
            this._ref.appendChild(document.createElement("br"));
          }

          this.emitChange(e);

          //return false;
        }


        e.preventDefault();
        e.stopPropagation();
      }
    }
  }
  focusMe() {
    this._ref.focus();
  }
  render() {
    this.loadCursorPos();
    return (
      <div className="pr">
        {this.show_placeholder?(
          <div className="pa pa-tl w100 w4 padd10">
            {this.props.placeholder}
          </div>
        ):null}
        <div
          contentEditable={true}
          ref={(ref)=>{ this._ref=ref; }}
          className={`pr editText padd10 ${this.props.className}`}
          dangerouslySetInnerHTML={{ __html: this._initialVal }}
          onInput={(e)=>{
            console.log("on change!!!!",e.target.innerHTML)
            this.props.linker.value=e.target.innerHTML;
          }}
          onKeyDown={(e)=>{ this.onKeyDown(e); }}
        />
      </div>
    )
  }
}

export default observer(ContentEditable);